import { render, staticRenderFns } from "./CriterioInputProdutos.vue?vue&type=template&id=24d3cc84"
import script from "./CriterioInputProdutos.vue?vue&type=script&lang=js"
export * from "./CriterioInputProdutos.vue?vue&type=script&lang=js"
import style0 from "./CriterioInputProdutos.vue?vue&type=style&index=0&id=24d3cc84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports